<script setup>
import BackButton from "@/components/global-themed/buttons/BackButton.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import {templateId, getTemplateContent, isAdminView} from "@/composables/email-templates/useEmailTemplates";
import MailForm from "@/components/email-templates/partials/MailForm.vue";
import MailPreview from "@/components/email-templates/partials/MailPreview.vue";
import {computed, onMounted} from "vue";

const props = defineProps({
  template: {
    type: Object,
    required: true,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { isLoading } = getTemplateContent();

const backUri = computed(() => props.adminView ? '/admin/email-templates' : '/mail');

onMounted(() => {
  templateId.value = props.template.id;
  isAdminView.value = props.adminView;
});
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-y-8">
      <div>
        <div class="tw-flex tw-items-center tw-justify-between">
          <h1 class="tw-font-bold tw-text-4.5xl tw-text-neutral-900">
            {{ adminView ? 'Admin ' : '' }}Email Template Manager
          </h1>
          <BackButton :href="backUri" />
        </div>

        <section v-if="adminView">
          <p class="tw-text-danger tw-text-base">
            <strong>Important:</strong> These emails must remain fully white-labeled and must not reference Kit, HIKE SEO, or any related branding.
          </p>
        </section>
      </div>


      <div
        v-if="isLoading"
        class="tw-bg-white tw-p-8 tw-rounded-lg"
      >
        <LoadingBlock />
      </div>

      <div
        v-else
        class="tw-grid tw-grid-cols-2 tw-gap-8 tw-items-start"
      >
        <MailForm />
        <MailPreview />
      </div>
    </div>
  </div>
</template>
